// @ts-ignore
import translate from 'translate-js';

import * as translations from './en/index';

Object.values(translations).forEach(t => translate.add(t, 'en'));
translate.setLocale('en');

export default translate;
